// extracted by mini-css-extract-plugin
export default {"navDescription":"r7kVxN3d"};